<div class="display-flex flex-align-center justify-content">
  <mat-spinner diameter="45"></mat-spinner>
</div>
